// services/fortigateService.js
import api from "./api";

export const getAllFortigates = async (schemaName = null) => {
  try {
    const response = await api.get("/fortigates/", {
        params: {
          ...(schemaName && { client: schemaName }),
        },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching fortigates:", error);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error(
        "Response data:",
        JSON.stringify(error.response.data, null, 2)
      );
      console.error(
        "Response headers:",
        JSON.stringify(error.response.headers, null, 2)
      );
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    throw error;
  }
};

export const getFortigateById = async (fortigateId, schemaName = null) => {
  try {
    const response = await api.get(`/fortigates/${fortigateId}/`, {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching fortigate:", error);
    throw error;
  }
};

export const updateFortigate = async (fortigateId, fortigateData, schemaName = null) => {
  try {
    const response = await api.put(`/fortigates/${fortigateId}/`, fortigateData, {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating fortigate:", error);
    throw error;
  }
};

export const createFortigate = async (fortigateData, schemaName = null) => {
  try {
    const response = await api.post("/fortigates/", fortigateData, {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating fortigate:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
      console.error("Response headers:", error.response.headers);
    }
    throw error;
  }
};

export const deleteFortigate = async (fortigateId, schemaName = null) => {
  try {
    const response = await api.delete(`/fortigates/${fortigateId}/`, {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting fortigate:", error);
    throw error;
  }
};

// Optional: Add pagination support
export const getFortigatesWithPagination = async ({
  page = 1,
  pageSize = 10,
  search = "",
  ordering = "-created_at",
}) => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      search,
      ordering,
    });

    const response = await api.get("/fortigates/", { params });
    return {
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    console.error("Error fetching fortigates with pagination:", error);
    throw error;
  }
};